module.exports = __webpack_public_path__ + "img/borne.a45a746d.png";